import { gql } from "@apollo/client";

// Registration token mint. No assetId/serial — payload is (customer, employee, exp);
// the agent supplies the serial at register time.
export const CREATE_ENROLLMENT_TOKEN = gql`
  mutation createEnrollmentToken {
    createEnrollmentToken {
      success
      message
      data {
        token
        expiresAt
      }
    }
  }
`;

// Unified reminder mutation — type selects the strategy, options carries the payload.
// download_agent_reminder  → options.employeeEmails
// fix_agents_check_reminder → options.assetId + options.failingChecks[{ name, reason }]
export const SEND_REMINDER_TO_EMPLOYEE = gql`
  mutation SendReminderToEmployee($type: ReminderType!, $options: ReminderOptionsInput) {
    sendReminderToEmployee(type: $type, options: $options) {
      success
      message
    }
  }
`;

// Whether Rego WatchTower is enabled for the tenant — gates the enroll UI.
export const WATCH_TOWER_STATUS = gql`
  query watchTowerStatus {
    watchTowerStatus {
      enabled
      integratedAccountId
    }
  }
`;

// Admin-only: enable Rego WatchTower as an MDM integration for the tenant.
export const ENABLE_WATCH_TOWER = gql`
  mutation enableWatchTower {
    enableWatchTower {
      success
      message
      enabled
      integratedAccountId
      alreadyEnabled
    }
  }
`;

// Admin-only: disconnect (soft-delete) Rego WatchTower for the tenant.
export const DISABLE_WATCH_TOWER = gql`
  mutation disableWatchTower {
    disableWatchTower {
      success
      message
      enabled
    }
  }
`;
